import React from 'react';
import { Dropdown, Menu, Button, Space } from 'antd';
import { EllipsisOutlined, PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { useChatActions } from '../hooks/useChatActions';
import { useLocation } from 'react-router-dom';

const ChatMenu = ({ chatId, className = '', style = {}, buttonStyle = {} }) => {
  const { handleNewChat, handleDeleteChat } = useChatActions();
  const pageUrl = useLocation();
  const disabledMenu = pageUrl.pathname === '/chat';

  const menu = (
    <Menu
      items={[
        {
          key: 'new',
          label: (
            <Space>
              <PlusOutlined />
              New chat
            </Space>
          ),
          onClick: handleNewChat,
          disabled: disabledMenu,
        },
        {
          type: 'divider',
        },
        {
          key: 'delete',
          danger: true,
          label: (
            <Space>
              <DeleteOutlined />
              Delete chat
            </Space>
          ),
          onClick: () => handleDeleteChat(chatId),
          disabled: disabledMenu,
        },
      ]}
    />
  );

  return (
    <div className={`chat-menu-container ${className}`} style={style}>
      <Dropdown overlay={menu} trigger={['click']} placement="bottomLeft">
        <Button type="text" icon={<EllipsisOutlined style={{ transform: 'rotate(90deg)' }} />} style={buttonStyle} />
      </Dropdown>
    </div>
  );
};

export default ChatMenu;
